import { GetChannelInstances } from '@/connection/integrations/integrations';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const fetchChannelInstancesReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const instances = await GetChannelInstances(channel);
        return instances;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.channelInstances = action.payload;
      },
    }
  );
};

export default fetchChannelInstancesReducer;
